import React, { useState, useCallback } from "react";
import Modal from 'react-bootstrap/Modal';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { getList_,} from "store/services/commonService";

export default ({oepnFilterVal, closeFilterModal, filter, setFilter, setListing, dispatch, setOepnFilterVal, activePage, limit}) => {
    
    const [isApplyFilter, setisApplyFilter] = useState(false);
    const handleChangeFilter = useCallback(
        (name) => (evt) => {
            setFilter((prevState) => ({
            ...prevState,
            [name]: evt.target.value,
          }));
        },
        []
    );

    const handleChangePicker = async (selectedDate, name) => {
    // Perform actions based on the selected date and field name
        let dateFormat = selectedDate ? selectedDate.format("YYYY-MM-DD") : "";
        
        setFilter((prev) => ({
        ...prev,
        [name]: dateFormat,
        }));
        // Rest of your code...
    };

    const onSubmitRecord = async () => {
        try{
            let query = {
                ...filter,
                url: "user/list",
                common: false,
            };
            setisApplyFilter(true)
            let res = await dispatch(getList_(query));
            setListing(res?.body?.data);
            setisApplyFilter(false)
            setFilter({
                page: activePage,
                limit: limit,
                sort_by: "",
                yearly_data:"",
                filter_gender:"",
                filter_age:"",
                date_val: "",
                search_string:""
            })
            setOepnFilterVal(false)
        }catch(err){
            console.log(err)
            setisApplyFilter(false)
        }
    };
    return(
        <>
            <Modal
                show={oepnFilterVal}
                onHide={closeFilterModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                <Modal.Title>Filter Record</Modal.Title>
                </Modal.Header>
                <hr/>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <option value="" selected>Sort by </option>
                            <select className="form-select filler_search" name="sort_by" value={filter?.sort_by} onChange={(e) => handleChangeFilter("sort_by")(e)}>
                                <option value="" selected>Select </option>
                                <option value="ASC" selected={filter?.sort_by === 'ASC'}>Oldest Player</option>
                                <option value="DESC" selected={filter?.sort_by === 'DESC'}>Newest Player </option>
                            </select>
                        </div>
                        <div className="form-group col-md-6">
                            <option value="" selected> By month/year/week </option>
                            <select className="form-select filler_search" name="yearly_data" onChange={(e) => handleChangeFilter("yearly_data")(e)}>
                                <option value="" selected>Select </option>
                                <option value="week" selected={filter?.yearly_data ==='week'}>Weekly</option>
                                <option value="month" selected={filter?.yearly_data === 'month'}>Monthly</option>
                                <option value="year" selected={filter?.yearly_data === 'year'}>Yearly</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <option value="" selected> By gender </option>
                            <select className="form-select filler_search" name="filter_gender" onChange={(e) => handleChangeFilter("filter_gender")(e)}>
                                <option value="" selected>Select </option>
                                <option value="male" selected={filter?.filter_gender === 'male'}>Male </option>
                                <option value="female" selected={filter?.filter_gender === 'female'}>Female</option>
                                <option value="both" selected={filter?.filter_gender === 'both'}>Both</option>
                            </select>
                        </div>
                        <div className="form-group col-md-6">
                            <option value="" selected> By age range </option>
                            <select className="form-select filler_search" name="filter_age" onChange={(e) => handleChangeFilter("filter_age")(e)}>
                                <option value="" selected>Select </option>
                                <option value="below_18" selected={filter?.filter_age === 'below_18'}>Below 18+</option>
                                <option value="above_18" selected={filter?.filter_age === 'above_18'}>Above 18+</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <option value="" selected>Filter by date </option>
                            <Datetime
                                inputProps={{
                                    placeholder: "YYYY-MM-DD",
                                    readOnly: true,
                                    className:"form-control class-time-date-time"
                                }}
                                name="date_val"
                                dateFormat="YYYY-MM-DD"
                                timeFormat={false}
                                onChange={(selectedDate) =>
                                    handleChangePicker(selectedDate, "date_val")
                                }
                                closeOnSelect={true}                  
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <button
                    type="submit"
                    onClick={onSubmitRecord}
                    disabled={isApplyFilter ? true : false}
                    className="btn btn-gradient-primary me-2"
                  >
                    {isApplyFilter ? "Wait.." : "Submit"}
                </button>
                <button
                    type="submit"
                    onClick={closeFilterModal}
                    className="btn btn-gradient-danger me-2"
                >
                Cancel
                </button>
                </Modal.Footer>
            </Modal>
        </>

    );
};